import { gql } from '@guuru/graphql-common/gql';

export default gql(`#graphql
  subscription QuizzResolved {
    quizzResolved
  }
`);
